import React from "react";

const ErrorComponent = ({ image, description }) => {
  return (
    <div className="d-flex mt-4 flex-column align-items-center p-6 justify-content-center bg-gray-100 rounded-lg shadow-md max-w-md mx-auto">
      <img src={image} alt="Error" className=" h-32 " style={{width:"200px", mixBlendMode:"multiply"}}/>
      <p className="text-center text-gray-700 text-lg font-semibold">{description}</p>
    </div>
  );
};

export default ErrorComponent;